var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "not_found" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "content" }, [
        _c("h1", [_vm._v("Error 404")]),
        _vm._v(" "),
        _c("p", { staticClass: "subtitle" }, [
          _vm._v("The page you're searching for could not be found."),
        ]),
        _vm._v(" "),
        _c("p", {
          staticClass: "description",
          domProps: { innerHTML: _vm._s(_vm.description) },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "cta_container" },
          [
            _vm.parsedPrimary
              ? _c("primary-button", {
                  attrs: {
                    label: _vm.parsedPrimary.title,
                    link: _vm.parsedPrimary,
                    theme: "reverse",
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.history.back()
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.parsedSecondary
              ? _c("secondary-button", {
                  attrs: {
                    label: _vm.parsedSecondary.title,
                    link: _vm.parsedSecondary,
                    theme: "reverse",
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.history.back()
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }